(function($) {
  var st = 0;
  $(window).on('scroll', function(event) {
    st = $(window).scrollTop();
    $('.menu [data-page="cooperate"]').each(function(ind) {
      var href = $(this).children('a').attr('href');
      var pos = 0;
      if (href.includes('#')) {
        var arr = href.split('#');
        pos = $('#'+arr[arr.length-1]).offset().top-$('.site-title').outerHeight();
      }
      // console.log(pos, st)
      if (st>=pos) {
        $(this).addClass('current').siblings().removeClass('current');
      }
    });
  }).scroll();
  
  $(window).on("load", function(){
    if ($('.js-counter').length) {
      const counterUp = window.counterUp.default;
      const els = document.querySelectorAll( '.js-counter' )
      els.forEach(el => {
        new Waypoint( {
            element: el,
            handler: function() { 
                counterUp( el ) 
                this.destroy()
            },
            offset: 'bottom-in-view',
        } )
      });
    }
    $('.cooperate3-slider').slick({
      autoplay: false,
      arrows: true,
      dots: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          }
        },
      ],
    });
    $('.cooperate4-slider').slick({
      autoplay: false,
      arrows: false,
      dots: true,
    });
  });
})($);